$(function() {
  
  $('.collection-description').on('click', '.collection-description__btn', function() {
    var $parent = $(this).parent();

    $parent.toggleClass('in');

    if ( $parent.hasClass('in') ) {
      $(this).html('Read Less');
    } else {
      $(this).html('Read More');
    }
  });
  
});

document.addEventListener('DOMContentLoaded', () => {
  const readMoreButton = document.querySelector('.read-more-button');
  const description = document.querySelector('.description');

  readMoreButton.addEventListener('click', () => {
    if (description.classList.contains('expanded')) {
      description.classList.remove('expanded');
      readMoreButton.textContent = 'Read more';
    } else {
      description.classList.add('expanded');
      readMoreButton.textContent = 'Read less';
    }
  });
});